export const LOCATION_PLACEHOLDER = 'Ville, code postal, adresse'
